import React, { useState, useMemo, useEffect, useContext } from "react"
import {
  Box,
  Button,
  TextField,
  Grid,
  CircularProgress,
  Paper,
  Select,
  MenuItem,
} from "@mui/material"
import { HelveticaBold, PoppinsSemiBold } from "common/typographies"
import i18n from "i18n"
import countryList from "react-select-country-list"
import currencyList from "./currency.json"
import languageList from "./language.json"
import EditOutlinedIcon from "@mui/icons-material/EditOutlined"
import ModalImage from "components/Profile/ModalImage"
import avatar1 from "assets/images/avatar/avatar1.png"
import AuthContext from "context/auth/authContext"
import ModalPassword from "components/Profile/ModalPassword"
import * as amplitude from "@amplitude/analytics-browser"

const ProfileComponent = () => {
  const [triedSubmit, setTriedSubmit] = useState(false)
  const [userInfo, setUserInfo] = useState({
    name: "",
    mobile: "",
    nif: "",
    email: "",
  })
  const countryOpts = useMemo(() => countryList().getData(), [])
  const currencyOpts = useMemo(() => currencyList, [])
  const idiomaOptions = useMemo(() => languageList, [])

  const [openImage, setOpenImage] = useState(false)
  const handleOpenImage = e => {
    e.preventDefault()
    setOpenImage(true)
  }
  const [openPassword, setOpenPassword] = useState(false)

  const [languageOptions, setLanguajeOptions] = useState({
    language: {},
    currency: {},
    country: {},
  })

  const { user, updateUser } = useContext(AuthContext)
  const [loading, setLoading] = useState(false)
  const [loading2, setLoading2] = useState(false)

  const [countryObj, setCountryObj] = useState({})
  const [currencyObj, setCurrencyObj] = useState({})
  const [languageObj, setLanguageObj] = useState("")

  const setCountry = () => {
    if (user["custom:pais"]) {
      const country = countryOpts.find(o => o.label === user["custom:pais"])
      if (country) {
        console.log("country found", country)
        setCountryObj(country)
      } else {
        console.log("country not found", user["custom:pais"])
        setCountryObj({ value: "ES", label: "España" })
      }
    } else {
      setCountryObj({ value: "ES", label: "España" })
    }
  }

  const setLanguage = () => {
    if (user["custom:idioma"]) {
      const language = idiomaOptions.find(
        o => o.value === user["custom:idioma"],
      )
      if (language) {
        console.log("language found", language)
        setLanguageObj(language)
      } else {
        console.log("language not found", user["custom:idioma"])
        setLanguageObj({ value: "es", label: "Castellano" })
      }
    } else {
      setLanguageObj({ value: "es", label: "Castellano" })
    }
  }

  const setCurrency = () => {
    if (user["custom:currency"]) {
      const currency = currencyOpts.find(
        o => o.value === user["custom:currency"],
      )
      if (currency) {
        console.log("currency found", currency)
        setCurrencyObj(currency)
      } else {
        console.log("currency not found", user["custom:currency"])
        setCurrencyObj({ value: "EUR", label: "Euro" })
      }
    } else {
      setCurrencyObj({ value: "EUR", label: "Euro" })
    }
  }

  useEffect(() => {
    if (user) {
      setCountry()
      setLanguage()
      setCurrency()
    }
  }, [])

  useEffect(() => {
    if (user) {
      setUserInfo({
        name: user["custom:nombre_apellido"] || "",
        mobile: user["custom:mobile"] || "",
        nif: user["custom:nif"] || "",
        email: user["email"] || "",
      })
    }
  }, [user])

  useEffect(() => {
    amplitude.track({
      event_type: "Profile visited",
      event_properties: { accountEmail: user?.email },
    })
  }, [])

  const [addressErrors, setAddressErrors] = useState({
    language: false,
    currency: false,
    country: false,
  })

  const handleChange = e => {
    setUserInfo({
      ...userInfo,
      [e.target.name]: e.target.value,
    })
  }

  useEffect(() => {
    console.log(`currencyObj=${JSON.stringify(currencyObj)}`)
  }, [currencyObj])

  const onChangeCountry = obj => {
    setCountryObj(obj)
  }

  const onChangeCurrency = obj => {
    console.log("onChangeCurrency", obj)
    setCurrencyObj({ value: obj.value, label: obj.label })
  }
  const changeHandler3 = value => {
    setLanguageObj(value)
  }

  const handleSubmit1 = async e => {
    e.preventDefault()
    setTriedSubmit(true)
    const isNameEmpty = userInfo.name.trim() === ""
    const isMobileEmpty = userInfo.mobile.trim() === ""
    const isNifEmpty = userInfo.nif.trim() === ""

    if (!isNameEmpty && !isMobileEmpty && !isNifEmpty) {
      setLoading(true)
      let userInfoParsed = {
        "custom:nombre_apellido": userInfo.name,
        "custom:mobile": userInfo.mobile,
        "custom:nif": userInfo.nif,
      }
      await updateUser(userInfoParsed)
      setLoading(false)
      setTriedSubmit(false)
    }
  }
  const handleSubmit2 = async e => {
    e.preventDefault()
    const errors = {
      language: !languageObj || !languageObj.value,
      currency: !currencyObj || !currencyObj.value,
      country: !countryObj || !countryObj.value,
    }
    setAddressErrors(errors)
    const isValid = !errors.language && !errors.currency && !errors.country
    if (isValid) {
      setLanguajeOptions({
        ...languageOptions,
        language: languageObj.value,
        currency: currencyObj.value,
        country: countryObj.value,
      })
      setLoading2(true)
      let userInfoParsed = {
        "custom:pais": countryObj.label,
        "custom:idioma": languageObj.value,
        "custom:currency": currencyObj.value,
      }
      await updateUser(userInfoParsed)
      setLoading2(false)
    }
  }

  return (
    <Box>
      <PoppinsSemiBold
        style={{ fontSize: "20px", marginLeft: "30px", marginBottom: "20px" }}
      >
        {i18n.t("profile.configuration")}
      </PoppinsSemiBold>
      <Box className="inline">
        <Grid
          container
          style={{
            backgroundColor: "transparent",
            height: "auto",
            marginLeft: "20px",
            marginRight: "20px",
            marginBottom: "50px",
            maxWidth: "908px",
          }}
          direction="row"
          spacing={1}
        >
          <Grid
            item
            xs={12}
            style={{
              paddingLeft: "12px",
              width: "100%",
              position: "relative",
            }}
          >
            <Paper elevation={0} sx={{ p: 3 }}>
              <HelveticaBold style={{ color: "#414141", fontSize: "20px" }}>
                {i18n.t("profile.user")}
              </HelveticaBold>

              <Box
                className="inline"
                sx={{ width: "100%", display: "flex", gap: 2, mb: 2 }}
              >
                {/* Avatar y cambiar foto */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    mr: 3,
                  }}
                >
                  <Box
                    sx={{
                      position: "relative",
                      width: 80,
                      height: 80,
                      mb: 1,
                      cursor: "pointer",
                    }}
                    onClick={handleOpenImage}
                  >
                    <img
                      src={user["custom:avatar"] || avatar1}
                      alt="avatar"
                      style={{
                        width: 80,
                        height: 80,
                        borderRadius: "50%",
                        objectFit: "cover",
                        border: "2px solid #E4E4E4",
                      }}
                    />
                    <Box
                      sx={{
                        position: "absolute",
                        bottom: 0,
                        right: 0,
                        bgcolor: "white",
                        borderRadius: "50%",
                      }}
                    >
                      <EditOutlinedIcon
                        sx={{ fontSize: 22, color: "#414141" }}
                      />
                    </Box>
                  </Box>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label={i18n.t("profile.fullName")}
                        variant="outlined"
                        fullWidth
                        size="small"
                        name="name"
                        value={userInfo.name}
                        onChange={handleChange}
                        error={triedSubmit && userInfo.name.trim() === ""}
                        helperText={
                          triedSubmit && userInfo.name.trim() === ""
                            ? i18n.t("profile.fieldRequired")
                            : ""
                        }
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label={i18n.t("profile.email")}
                        variant="outlined"
                        fullWidth
                        size="small"
                        name="email"
                        value={userInfo.email}
                        disabled
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label={i18n.t("profile.phone")}
                        variant="outlined"
                        fullWidth
                        size="small"
                        name="mobile"
                        value={userInfo.mobile}
                        onChange={handleChange}
                        error={triedSubmit && userInfo.mobile.trim() === ""}
                        helperText={
                          triedSubmit && userInfo.mobile.trim() === ""
                            ? i18n.t("profile.fieldRequired")
                            : ""
                        }
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label={i18n.t("profile.nif")}
                        variant="outlined"
                        fullWidth
                        size="small"
                        name="nif"
                        value={userInfo.nif}
                        onChange={handleChange}
                        error={triedSubmit && userInfo.nif.trim() === ""}
                        helperText={
                          triedSubmit && userInfo.nif.trim() === ""
                            ? i18n.t("profile.fieldRequired")
                            : ""
                        }
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  variant="contained"
                  color="branded"
                  onClick={handleSubmit1}
                  sx={{ width: "110px" }}
                  disabled={loading}
                >
                  {loading ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    i18n.t("profile.save")
                  )}
                </Button>
              </Box>
            </Paper>
          </Grid>
          <Grid
            item
            xs={12}
            spacing={3}
            style={{
              paddingLeft: "12px",
              height: "370px",
              marginTop: "20px",
            }}
          >
            <Paper elevation={0} sx={{ p: 3, mb: 4 }}>
              <HelveticaBold style={{ color: "#414141", fontSize: "20px" }}>
                {i18n.t("profile.regional")}
              </HelveticaBold>

              <Grid container spacing={2} sx={{ marginBottom: "16px" }}>
                {/* <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    select
                    label={i18n.t("profile.language")}
                    value={languageObj?.value || ""}
                    onChange={e => {
                      const selected = idiomaOptions.find(
                        opt => opt.value === e.target.value,
                      )
                      changeHandler3(selected)
                      setAddressErrors({ ...addressErrors, language: false })
                    }}
                    variant="outlined"
                    size="small"
                    name="language"
                    error={addressErrors.language}
                    helperText={
                      addressErrors.language
                        ? i18n.t("profile.fieldRequired")
                        : ""
                    }
                  >
                    {idiomaOptions.map(opt => (
                      <MenuItem key={opt.value} value={opt.value}>
                        {opt.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid> */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    select
                    label={i18n.t("profile.currency")}
                    value={currencyObj?.value || ""}
                    onChange={e => {
                      const selected = currencyOpts.find(
                        opt => opt.value === e.target.value,
                      )
                      onChangeCurrency(selected)
                      setAddressErrors({ ...addressErrors, currency: false })
                    }}
                    variant="outlined"
                    size="small"
                    name="currency"
                    error={addressErrors.currency}
                    helperText={
                      addressErrors.currency
                        ? i18n.t("profile.fieldRequired")
                        : ""
                    }
                  >
                    {currencyOpts.map(opt => (
                      <MenuItem key={opt.value} value={opt.value}>
                        {opt.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    select
                    label={i18n.t("profile.country")}
                    value={countryObj?.value || ""}
                    onChange={e => {
                      const selected = countryOpts.find(
                        opt => opt.value === e.target.value,
                      )
                      onChangeCountry(selected)
                      setAddressErrors({ ...addressErrors, country: false })
                    }}
                    variant="outlined"
                    size="small"
                    name="country"
                    error={addressErrors.country}
                    helperText={
                      addressErrors.country
                        ? i18n.t("profile.fieldRequired")
                        : ""
                    }
                  >
                    {countryOpts.map(opt => (
                      <MenuItem key={opt.value} value={opt.value}>
                        {opt.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  variant="contained"
                  color="branded"
                  onClick={handleSubmit2}
                  disabled={loading2}
                  sx={{ width: "110px" }}
                >
                  {loading2 ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    i18n.t("profile.save")
                  )}
                </Button>
              </Box>
            </Paper>

            <Paper elevation={0} sx={{ p: 3 }}>
              <HelveticaBold style={{ color: "#414141", fontSize: "20px" }}>
                {i18n.t("profile.security")}
              </HelveticaBold>
              <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
                <Button
                  variant="contained"
                  color="branded"
                  onClick={() => setOpenPassword(true)}
                >
                  {i18n.t("profile.changePassword")}
                </Button>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Box>
      <ModalImage
        openImage={openImage}
        setOpenImage={setOpenImage}
        user={user}
        first={true}
      />
      <ModalPassword
        openPassword={openPassword}
        setOpenPassword={setOpenPassword}
        user={user}
      ></ModalPassword>
    </Box>
  )
}

export default ProfileComponent
